module.exports = __webpack_public_path__ + "static/media/bg.4b50b11d.svg";